"use strict";
(function () {
    // Add first string as Id to identify subquestions and answers
    var helpHeaders = dqa(".helpHeader");
    helpHeaders.forEach(function (header, index) {
        var span = header.querySelector("h4 span");
        if (!span) {
            return;
        }
        var assignId = span.textContent;
        var finalId = assignId === null || assignId === void 0 ? void 0 : assignId.split(" ")[0].toLowerCase();
        if (finalId) {
            var helpBody = header.nextElementSibling;
            helpBody.setAttribute("id", finalId);
            header.setAttribute("id", finalId);
        }
    });
    // Add number. id to each helpBody/answer
    var questionHeaders = dqa(".helpBody .questionHeader");
    questionHeaders.forEach(function (header, index) {
        var helpBody = header.parentElement;
        var helpId = helpBody.getAttribute("id");
        header.setAttribute("id", helpId + "-" + index);
        var answer = header.querySelector(".answer");
        answer.setAttribute("id", helpId + "-" + index);
        var questionTitle = header.querySelector(".questionTitle");
        questionTitle.setAttribute("id", "lower");
    });
    var questionTitles = document.querySelectorAll(".questionTitle");
    questionTitles.forEach(function (title) {
        title.addEventListener("click", function (event) {
            var _a;
            var currentTarget = event.currentTarget;
            currentTarget.classList.toggle("questionActive");
            var icon = currentTarget.nextElementSibling;
            icon.classList.toggle("iconActive");
            var titleId = currentTarget.getAttribute("id");
            if (titleId === "lower") {
                var header = currentTarget.parentElement;
                var answer = header.nextElementSibling;
                answer.classList.toggle("showAnswer");
            }
            else {
                var sectionId = "#" + currentTarget.closest(".helpHeader").getAttribute("id");
                var helpBody = (_a = dq(sectionId)) === null || _a === void 0 ? void 0 : _a.nextElementSibling;
                helpBody.classList.toggle("showAnswer");
            }
        });
    });
    var showContact = document.querySelector(".showContact");
    showContact.addEventListener("click", function () {
        var myForm = document.querySelector(".myForm");
        myForm.style.display = "block";
    });
    var close = document.querySelector(".close");
    close.addEventListener("click", function () {
        var myForm = document.querySelector(".myForm");
        myForm.style.display = "none";
    });
})();
